<div class="relative flex items-center py-2">
  <div class="flex-grow border-t border-slate-300 dark:border-slate-700"></div>
  @if (text()) {
  <span class="flex-shrink-0 mx-4 text-slate-400 text-sm font-medium"
    >{{ text() }}</span
  >
  }
  <div class="flex-grow border-t border-slate-300 dark:border-slate-700"></div>
</div>
